import { actionTypes } from "../constants/actionTypes";

const initialState = null;

const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_USER:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default userReducer;
